/**
 * Booster: directional impulse applied once per contact entry.
 * Sensor body; the GameScene reads vx/vy and sets velocity on the ragdoll.
 */

import Matter from 'matter-js';
import { Graphics } from 'pixi.js';

export interface BoosterOptions {
  x: number;
  y: number;
  w: number;
  h: number;
  vx?: number;
  vy?: number;
}

export class Booster {
  readonly body: Matter.Body;
  readonly view: Graphics;
  readonly vx: number;
  readonly vy: number;

  constructor(opts: BoosterOptions) {
    this.vx = opts.vx ?? 18;
    this.vy = opts.vy ?? 0;
    this.body = Matter.Bodies.rectangle(
      opts.x + opts.w / 2,
      opts.y + opts.h / 2,
      opts.w,
      opts.h,
      { isStatic: true, isSensor: true, label: 'booster' },
    );

    const g = new Graphics();
    g.roundRect(opts.x, opts.y, opts.w, opts.h, 8)
      .fill({ color: 0xffcc33, alpha: 0.85 })
      .stroke({ color: 0x664400, width: 2 });
    // Arrow showing direction.
    const cx = opts.x + opts.w / 2;
    const cy = opts.y + opts.h / 2;
    const len = Math.min(opts.w, opts.h) * 0.4;
    const ang = Math.atan2(this.vy, this.vx);
    const tipX = cx + Math.cos(ang) * len;
    const tipY = cy + Math.sin(ang) * len;
    const tailX = cx - Math.cos(ang) * len;
    const tailY = cy - Math.sin(ang) * len;
    g.moveTo(tailX, tailY).lineTo(tipX, tipY).stroke({ color: 0x222222, width: 4 });
    // Arrowhead.
    const head = 10;
    g.moveTo(tipX, tipY)
      .lineTo(tipX - Math.cos(ang - 0.4) * head, tipY - Math.sin(ang - 0.4) * head)
      .moveTo(tipX, tipY)
      .lineTo(tipX - Math.cos(ang + 0.4) * head, tipY - Math.sin(ang + 0.4) * head)
      .stroke({ color: 0x222222, width: 4 });
    this.view = g;
  }
}
